import React, { useEffect, useMemo, useState } from 'react'
import CustomTable from '../../../../customControl/CustomTable'
import { getDateCombination, isImageValidPng, onlyAlphabets } from '../../../commonClass/CommonValidation';
import "../../../../assets/css/master.css"
import Switch from 'react-switch';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { deleteUserData, getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import { useNavigate } from 'react-router-dom';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import CustomColumn from '../../../../customControl/CustomColumn';

export const getTitleName = (id) => {
    switch (id) {
        case 1: return 'Flights Merchandising';
        case 2: return 'Holidays Merchandising';
        case 5: return 'Hotels Merchandising';
        case 6: return 'Activities Merchandising';
        default: return '';
    }
}

const HomePageActivities = ({ travelCategoryId, useredit, useradd }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = GetLocalStorage();
    const [homePageSection, setHomePageSection] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [sectionList, setSectionList] = useState([]);
    const [imageList, setImageList] = useState([]);
    const [deletImageList, setDeleteImageList] = useState([]);
    const [formError, setFormError] = useState(null);

    const getFolderName = (id) => {
        switch (id) {
            case 1: return 'Flights';
            case 2: return 'Holidays';
            case 5: return 'Hotels';
            case 6: return 'Activities';
            default: return '';
        }
    }
    
    const folderName = getFolderName(travelCategoryId);

    //#region for upload Banner images and add Link field for Other Products sections
    const forPromotionalBannerIds = useMemo(() => {
        const commonIds = [8, 9, 10, 11];
        switch (travelCategoryId) {
            case 1: return [1, 2, ...commonIds];
            case 2: return [4, 5, ...commonIds];
            case 5: return [...commonIds];
            default: return [...commonIds];
        }
    }, [travelCategoryId]);

    const forOtherProductIds = useMemo(() => {
        return [9, 10, 11];
    }, []);

    const getSubFolderName = (id) => {
        switch (id) {
            case 9: return 'Flights';
            case 10: return 'Holidays';
            case 11: return 'Hotels';
            default:
                break;
        }
    }

    const sections = useMemo(() =>
        [homePageSection]?.reduce((acc, curr) => {
            acc.isPromotionalBanner = forPromotionalBannerIds?.includes(curr?.HomePageSectionId);
            acc.isOtherProduct = forOtherProductIds?.includes(curr?.HomePageSectionId);
            acc.fieldLabel = curr?.HomePageSectionId === 8 ? 'Promotional Banner Type 2' : forOtherProductIds?.includes(curr?.HomePageSectionId) ? curr?.Name : curr?.Section
            acc.subFolderName = forOtherProductIds?.includes(curr?.HomePageSectionId) ? getSubFolderName(curr?.HomePageSectionId) : curr?.Section
            return acc
        }, { isPromotionalBanner: false, isOtherProduct: false, fieldLabel: '', subFolderName: '' })
        , [forOtherProductIds, forPromotionalBannerIds, homePageSection])
    //#endregion

    const getSectionList = async (travelCategoryId) => {
        const section = await getAllData(`/master/v1/gethomepagesectionlistbytravelcategpryid?travelCategoryId=${travelCategoryId}`);
        if (section?.status) {
            setSectionList(section?.data);
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end());
            dispatch({ type: 'ALERTING', message: section.message })
            return;
        }
    }

    //#region List data
    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getSectionList(travelCategoryId)
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }, []);

    const onEditorView = async (data, type) => {
        setFormError(null);
        const gethomepagesectionbyid = await getAllData(`/master/v1/gethomepagesectionbyid?homePageSectionId=${data?.HomePageSectionId}`);
        if (gethomepagesectionbyid?.status) {
            setHomePageSection({ ...gethomepagesectionbyid?.data?.homePageSection[0], type })
            setImageList(gethomepagesectionbyid?.data?.homePageSectionBanner)
            setDeleteImageList(gethomepagesectionbyid?.data?.homePageSectionBanner)
        }
    }

    const routeMap = {
        '/MerchandisingDomestic': [4, 19, 16],
        '/MerchandisingInternational': [5, 18],
        '/MerchandisingDomesticPackage': [6],
        '/MerchandisingInternationalPackage': [7],
        '/MerchandisingCollection': [15],
    };

    const onOpen = (section, name, HomePageSectionId) => {
        if (section === "Popular") {
            navigate('/MerchandisingPopular', { state: { useredit: useredit, useradd: useradd, name: name, travelCategoryId: travelCategoryId, HomePageSectionId: HomePageSectionId } });
            return;
        }

        const targetRoute = Object.keys(routeMap)?.find(route =>
            routeMap?.[route]?.includes(HomePageSectionId)
        );

        if (targetRoute) {
            navigate(targetRoute, {
                state: {
                    useredit: useredit,
                    useradd: useradd,
                    name: name,
                    travelCategoryId: travelCategoryId,
                    HomePageSectionId: HomePageSectionId,
                    folderName: folderName,
                    section: section
                }
            });
            return;
        }
    }

    const columns = [
        {
            name: 'Sr. No',
            sortable: true,
            float: "left",
            minWidth: "20px",
            maxWidth: "20px",
            selector: (data, index) => index + 1,
        },
        {
            name: 'Section',
            sortable: true,
            float: "left",
            selector: (data) => data.Section,
        },
        {
            name: 'Name',
            sortable: true,
            float: "left",
            selector: (data) => data.Name,
        },
        {
            name: 'Active/Inactive',
            sortable: true,
            float: "left",
            selector: (data) => data.Status,
        },
        {
            name: 'Edit',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr'
                onClick={() => onEditorView(data, 'edit')}
                disabled={!useredit}
            ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'view')} ><i className="fa fa-eye" ></i></button>
        },
        {
            name: 'Open',
            selector: data => data?.HomePageSectionId !== 17 ? (
                <button
                    className="btn btn-primary mx-1 home-page-section-btn"
                    id="btnAdd" type='button'
                    onClick={() => onOpen(data?.Section, data?.Name, data?.HomePageSectionId)}
                >
                    open
                </button>
            ) : ("")
        },
    ]

    const handleOnChange = (e) => {
        setFormError(null);
        let result;
        if (e.target.name === 'Link') {
            result = e.target.value
        }
        else {
            result = onlyAlphabets(e.target.value)
        }
        setHomePageSection({
            ...homePageSection,
            [e.target.name]: result
        })
    }

    const handleisActive = (e) => {
        if (!homePageSection?.IsActive) {
            setFormError(null);
            setHomePageSection({ ...homePageSection, IsActive: !homePageSection?.IsActive })
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormError(null);
            setHomePageSection({ ...homePageSection, IsActive: !homePageSection?.IsActive })
        }
        setModalShow(false);
    }

    const validateData = () => {
        let status = true;
        let error = {}

        if (homePageSection?.HomePageSectionId === 17 && imageList?.length <= 0) {
            error.imageUpload = 'Cannot leave blank, input is mandatory.';
            status = false;
        }

        if (homePageSection?.Name?.trim()?.length <= 0) {
            error.Name = 'Kinldy enter section Name.';
            status = false;
        }

        setFormError(error);
        return status;
    }

    const onSubmitData = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let newImageList = imageList?.filter((obj) => obj?.needToUpload)
                const updateSection = await postUsersData('/master/v1/insertorupdatehomepagesection',
                    {
                        HomePageSectionId: homePageSection?.HomePageSectionId,
                        TravelCategoryId: travelCategoryId,
                        Link: homePageSection?.Link,
                        Name: homePageSection?.Name,
                        Description: homePageSection?.Description || "",
                        IsActive: homePageSection.IsActive,
                        UserId: userId?.userMasterID,
                        ImageList: newImageList
                    }
                );

                if (updateSection.status) {
                    await Promise.all(
                        newImageList?.map(async (ele) => {
                            if (ele?.needToUpload) {
                                try {
                                    let uploaded = await ImageUpload(ele?.Path, ele?.ImageName, ele?.File);
                                    if (sections.isOtherProduct && deletImageList?.length > 0) {
                                        await deletehomepagesectionbyid(deletImageList[0]?.HomePageSectionBannerId, 'newImage');
                                    }
                                    ele.uploaded = uploaded
                                } catch (error) {
                                    console.error(`Error Upload Image/Video: ${error}`)
                                    dispatch(loaderActions.end())
                                }
                            }
                            return ele;
                        })
                    )
                    setHomePageSection({});
                    setImageList([]);
                    setFormError(null);

                    getSectionList(travelCategoryId);
                    dispatch({ type: 'ALERTING', message: updateSection.message })
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: updateSection.message })
                    dispatch(loaderActions.end());
                    return;
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
    }

    const handleUploadDoc = (e, sectionId) => {
        setFormError({});
        const files = Array?.from(e?.target?.files || []);
        let newFileType = files?.filter((file) => isImageValidPng(file?.name))
        let newFileSize = newFileType?.filter((file) => ((file?.size / 1024) / 1024) < 5)
        let error = {}
        if (files?.length !== newFileType?.length) {
            error.imageUpload = 'Only PNG file type is accepted.';
            setFormError(error);
        }
        else if (files?.length !== newFileSize?.length) {
            error.imageUpload = 'Cannot upload file that exceeds 5 MB.';
            setFormError(error);
        }
        const tempImageList = newFileSize?.reduce((acc, file, index) => {
            const filename = getDateCombination(file?.name);
            acc.push({
                HomePageSectionBannerId: 0,
                ImageName: filename,
                ImagePath: `CMS/Merchandising/${folderName}/HomePage/${sections?.subFolderName}/${filename}`,
                Path: `CMS/Merchandising/${folderName}/HomePage/${sections?.subFolderName}/`,
                File: file,
                needToUpload: true,
                uploaded: false,
            });

            return acc;
        }, []);
        if (sections?.isOtherProduct) {
            setImageList(tempImageList)
        }
        else {
            setImageList((prev) => [...prev, ...tempImageList])
        }
    }

    const handleDeleteFile = (mediaId, indexId) => {
        setFormError(null);
        if (mediaId === 0) {
            setImageList((prev) => prev.filter((item, index) => index !== indexId));
        }
        else {
            deletehomepagesectionbyid(mediaId, 'oldImage')
            setImageList((prev) => prev.filter((item, index) => index !== indexId));
        }
    }

    const deletehomepagesectionbyid = async (mediaid, type) => {
        dispatch(loaderActions.start())
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const deleteData = await deleteUserData(`/master/v1/deletehomepagesectionbyid?homePageSectionBannerId=${mediaid}`)
            if (deleteData?.status) {
                let delColl = (type === 'newImage' && sections.isOtherProduct) ? deletImageList : imageList;
                let deleteImage = delColl?.find((obj) => obj?.HomePageSectionBannerId === mediaid);
                try {
                    const deleted = await ImageDelete(deleteImage?.ImagePath);
                    if (deleted) {
                        dispatch(loaderActions.end())
                        dispatch({ type: 'ALERTING', message: deleteData?.message })
                    }
                } catch (error) {
                    console.error(`Error Delete Image: ${error}`)
                }
            }
            else {
                dispatch(loaderActions.end())
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }

    }

    return (
        <div className='px-xl-5 py-4 p-xl-4'>
            <div className=" heading_color mb-3">
                <h4>Home Page Section</h4>
            </div>

            <form action=" " >
                <div class="row mb-3">
                    <CustomColumn labelText='Section' labelId='Section_activity' isRequired >
                        <input
                            type="text"
                            id="Section"
                            className="form-control"
                            name="Section"
                            value={homePageSection.Section || ''}
                            onChange={handleOnChange}
                            placeholder="Section"
                            disabled={true}
                        />
                    </CustomColumn>

                    <CustomColumn labelText='Name' labelId='section-ui-name' isRequired >
                        <div class="input-group">
                            <input
                                type="text"
                                id="section-ui-name"
                                class="form-control btn_add"
                                placeholder="Name"
                                maxLength={50}
                                name='Name'
                                value={homePageSection.Name || ''}
                                onChange={handleOnChange}
                                disabled={homePageSection?.type === 'view' ? true : false}
                            />
                        </div>
                        {formError?.Name && <p className="text-start text-danger mb-0"> {formError?.Name} </p>}
                    </CustomColumn>

                    {homePageSection?.HomePageSectionId === 17 && (
                        <React.Fragment>
                            <CustomColumn labelText='Upload Images' labelId='imageUpload' isRequired >
                                <div className="input-group">
                                    <input type="file"
                                        multiple
                                        className="form-control btn_add"
                                        id="imageUpload"
                                        name='imageUpload'
                                        accept='.png'
                                        disabled={homePageSection?.type === 'view' ? true : false}
                                        onChange={(e) => handleUploadDoc(e)}
                                    />
                                    <label className="input-group-text" htmlFor="imageUpload">Browse</label>
                                </div>
                                {formError?.imageUpload && <p className="text-start text-danger mb-0"> {formError?.imageUpload} </p>}
                            </CustomColumn>

                        </React.Fragment>
                    )}

                    {
                        [16, 17]?.includes(homePageSection?.HomePageSectionId) &&
                        <React.Fragment>
                            <CustomColumn labelText='Description' labelId='Description'>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        id="Description"
                                        class="form-control btn_add"
                                        placeholder="Description"
                                        maxLength={100}
                                        name='Description'
                                        value={homePageSection.Description || ''}
                                        onChange={handleOnChange}
                                        disabled={homePageSection?.type === 'view' ? true : false}
                                    />
                                </div>
                            </CustomColumn>
                        </React.Fragment>
                    }



                    <div className='col-md-6'>
                        <div className='row align-items-center'>
                            <div class="col-xl-4 col-6 mb-1">
                                <label for="inputPassword6" class="col-form-label">Active/Inactive</label>
                            </div>

                            <div class="col-xl-8 col-6 mb-lg-1 mb-md-1">
                                <div class="input-group">
                                    <Switch
                                        id='active'
                                        onChange={handleisActive}
                                        checked={homePageSection?.IsActive}
                                        className="react-switch"
                                        disabled={homePageSection?.type === 'view' ? true : false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    {
                        imageList?.map((img, index) => {
                            return (
                                <div className={` ${sections?.isOtherProduct ? 'text-center col-6' : 'col-xl-2 col-lg-3 col-md-6 col-12'} py-2`} key={index} >
                                    <img
                                        src={
                                            img?.needToUpload ?
                                                URL.createObjectURL(img?.File) :
                                                `${CommonFileURLWithFolder}${img?.ImagePath}`
                                        }
                                        key={index}
                                        className={` ${sections?.isOtherProduct ? 'home_other_img' : 'home_banner_img'} `}
                                        alt={img?.ImageName}
                                        loading='lazy'
                                    />
                                    <button className='closebtnimg'
                                        onClick={(e) => handleDeleteFile(img?.HomePageSectionBannerId, index)}
                                        type="button"
                                        disabled={homePageSection?.type === 'view' ? true : false}
                                    >&times;</button>
                                </div>
                            )
                        })
                    }
                </div>

                <CustomTable
                    columns={columns}
                    data={sectionList}
                    PdfExport={false}
                    ExportToExcel={false}
                    disabled={false}
                    className={'Homepage-section'}
                />
            </form>

            <div class="d-flex justify-content-center">
                <button class="btn btn-primary mx-1" id="btnAdd" type='button'
                    onClick={() => onSubmitData()}
                    disabled={!homePageSection?.HomePageSectionId ? true : false || homePageSection?.type === 'view' ? true : false || !useredit}
                >Update</button>
                <button type="button" class="btn btn-primary mx-1" id="btnClear"
                    onClick={() => {
                        setHomePageSection({});
                        setImageList([]);
                        setFormError(null);
                    }}
                // disabled={Object.keys(homePageSection).length === 0 ? true : false || homePageSection?.type === 'view' ? true : false}
                >Clear</button>
            </div>

            <ConfirmationModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                noconfirm={() => handleConfirmation(false)}
                yesconfirm={() => handleConfirmation(true)}
            />
        </div>
    )
}

export default HomePageActivities